import $ from 'jquery' // jQuery

$(function () {
  // menu
  $('.menu-bar').click(function (e) {
    $(this).toggleClass('on')
    $('#main-header .navGlobal').toggleClass('show-menu')
    $('html').toggleClass('none-scroll')
  })

  $('form').on('submit', function () {
    $('#contact_hash').val($('#token').val())
  })

  var heightHeader = $('#main-header').outerHeight()
  $('#index').css('margin-top', heightHeader)
  $(window).on('load resize', function (e) {
    var heightHeader = $('#main-header').outerHeight()
    $('#index').css('margin-top', heightHeader)
  })

  $(document).on('scroll', onScroll)
  //smoothscroll
  $("a[href^='#']").on('click', function (e) {
    e.preventDefault()
    var headerHeight = $('#main-header').outerHeight()
    $(document).off('scroll')
    $('.navGlobalIn a').each(function () {
      $(this).removeClass('active')
    })
    $(this).addClass('active')

    var speed = 500
    var href = $(this).attr('href')
    var target = $(href == '#' || href == '' ? 'html' : href)
    var position = target.offset().top - headerHeight
    $('body,html').animate({ scrollTop: position }, speed, 'swing', function () {
      window.location.hash = position
      $(document).on('scroll', onScroll)
    })
    $('.menu-bar').removeClass('on')
    $('#main-header .navGlobal').removeClass('show-menu')
    $('html').removeClass('none-scroll')
    return false
  })
})

function onScroll(event) {
  var headerHeight = $('#main-header').outerHeight()
  var scrollPos = $(document).scrollTop() + headerHeight
  $('.navGlobalIn a').each(function () {
    var currLink = $(this)
    var hash = currLink.attr('href').split('#')[1]
    var refElement = $('#' + hash)

    if (refElement.position().top <= scrollPos && refElement.position().top + refElement.outerHeight() > scrollPos) {
      $('.navGlobalIn a').removeClass('active')
      currLink.addClass('active')
    } else {
      currLink.removeClass('active')
    }
  })
}

$(function () {
  var setArea = $('.scrEvent'),
    showHeight = 150

  $(window).on('load scroll resize', function () {
    setArea.each(function () {
      var setThis = $(this),
        areaTop = setThis.offset().top

      if ($(window).scrollTop() >= areaTop + showHeight - $(window).height()) {
        setThis.stop().addClass('fadeIn')
      } else {
        setThis.stop().removeClass('fadeIn')
      }
    })
  })
})
